import {
  getData,
  postData
} from './api-base.service'


export const saveUniversityAdvanceEnrollments = (models) => {
  let data = models;
  let fetchResult = postData('/advanceEnrollment/saveUniversityAdvanceEnrollments', data);

  return fetchResult;
}

export const getUniversityAdvanceEnrollments = (getAll) => {
  if (typeof getAll == "undefined"){
    getAll = false;
  }
  return postData('/advanceEnrollment/getUniversityAdvanceEnrollments?getAll='+ getAll);
}

export const getStudentAdvanceEnrollmentByStudentId = (studentid) => {
  return getData('/advanceEnrollment/GetStudentAdvanceEnrollmentByStudentId', {studentid : studentid});
}
export const getAllStudentAdvanceEnrollmentByStudentId = (studentid) => {

  let fetchResult = getData('/advanceEnrollment/GetAllStudentAdvanceEnrollmentByStudentId', { studentid: studentid });

  return fetchResult;
}



// WEBPACK FOOTER //
// ./src/service/advanceEnrollment.service.js